var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconLink = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1772 5.74336L12.3461 7.57444C11.8775 8.04308 11.1177 8.04308 10.649 7.57444C10.1804 7.1058 10.1804 6.34599 10.649 5.87736L12.4899 4.03653L12.5081 4.01864C13.5742 2.99708 14.998 2.43381 16.4745 2.44954C17.9509 2.46527 19.3624 3.05877 20.4064 4.1028C21.4505 5.14684 22.044 6.55834 22.0597 8.03475C22.0754 9.51116 21.5122 10.935 20.4906 12.001L20.4727 12.0193L18.6319 13.8601C18.1632 14.3288 17.4034 14.3288 16.9348 13.8601C16.4661 13.3915 16.4661 12.6317 16.9348 12.1631L18.7659 10.332C19.348 9.72006 19.6688 8.90517 19.6598 8.06033C19.6507 7.21155 19.3096 6.4001 18.7093 5.79989C18.1091 5.19968 17.2977 4.85849 16.4489 4.84944C15.604 4.84044 14.7891 5.16123 14.1772 5.74336Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.57448 9.64911C9.04312 10.1177 9.04312 10.8776 8.57448 11.3462L6.74339 13.1773C6.16125 13.7892 5.84046 14.6041 5.84946 15.4489C5.85851 16.2977 6.1997 17.1092 6.79991 17.7094C7.40013 18.3096 8.21159 18.6508 9.06037 18.6598C9.90522 18.6688 10.7201 18.348 11.332 17.7659L13.1631 15.9348C13.6318 15.4662 14.3916 15.4662 14.8602 15.9348C15.3289 16.4035 15.3289 17.1633 14.8602 17.6319L13.0194 19.4727L13.0011 19.4906C11.9351 20.5122 10.5112 21.0754 9.03479 21.0597C7.55837 21.044 6.14686 20.4505 5.10282 19.4065C4.05877 18.3624 3.46527 16.9509 3.44954 15.4745C3.43381 13.9981 3.99709 12.5743 5.01865 11.5082L5.03654 11.4899L6.87738 9.64911C7.34602 9.18048 8.10584 9.18047 8.57448 9.64911Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1179 8.39167C16.5865 8.86031 16.5865 9.62012 16.1179 10.0888L11.0889 15.1176C10.6203 15.5863 9.86049 15.5863 9.39185 15.1176C8.92321 14.649 8.92321 13.8892 9.39185 13.4206L14.4208 8.39167C14.8894 7.92303 15.6492 7.92303 16.1179 8.39167Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconLink);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "media/IconLink.ea3d557ff753a858745d80168064c5e0.svg";